import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Ostatnia aktywność',
  actions: {
    clicked: 'Kliknięto',
    open: 'Otwarto',
    scheduled: 'Zaplanowano',
    sent: 'Wysłano',
  },
  fields: {
    recipients: '{{recipients}} odbiorców',
    opened: '{{rate}} otwarto',
    clicked: '{{rate}} kliknięto',
    awaiting: 'Oczekuje na potwierdzenie',
  },
  template_types: TemplateNames,
};
